import React from 'react';

export const DividerWithText = ({ text = 'OR CONTINUE WITH' }) => (
  <div className="divider-container">
    <div className="divider-line"></div>
    <span className="divider-text">{text}</span>
    <div className="divider-line"></div>
  </div>
);

export default DividerWithText;
